import formInputsTypes from '../simulatorConstant';
export const TOILE_STORE_BANNE = 5379;
export const FIXATION_ATTRIBUTE = 26;

import droite from 'assets/img/stock/store/Droite.jpg';
import gauche from 'assets/img/stock/store/Gauche.jpg';

import Filaire from 'assets/img/stock/Filaire.png';
import Radio from 'assets/img/stock/Radio.png';
import Solaire from 'assets/img/stock/Solaire.png';
import StoreCapteurVent from 'assets/img/store-capteur-vent.png';
import StoreSansCapteurVent from 'assets/img/store-sans-capteur-vent.png';
export const capteur = {
	id: 'capteur_vent',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Capteur de vent',
	name: 'capteur_vent',
	nextStepData: false,
	nextStep: false,
	options: null,

	fetchData: (tokenUserCurent, currentFormValue, fnSuccess) => {
		let data = '';
		const generateDescription = (data) => {
			return ` ${
				currentFormValue?.StoreBanneData ? `` + currentFormValue?.StoreBanneData?.value : ''
			} ${
				currentFormValue?.manoeuvre_store
					? ` ` + currentFormValue?.manoeuvre_store?.value + ' complet'
					: ''
			} ${
				currentFormValue?.TypeStorebanne
					? ` \n - Store banne ` + currentFormValue?.TypeStorebanne?.label
					: ''
			} ${
				currentFormValue?.largeurToile
					? ` \n - Largeur de store banne ` + currentFormValue?.largeurToile + ' (mm)'
					: ''
			} ${
				currentFormValue?.avancee ? `\n - Avancée ` + currentFormValue?.avancee?.label : ''
			} ${data ? `\n - ` + data : ''} ${
				currentFormValue?.lambrequin ? `\n - ` + currentFormValue?.lambrequin?.value : ''
			} ${
				currentFormValue?.telecommande
					? `\n - ` + currentFormValue?.telecommande?.value
					: ''
			} ${
				currentFormValue?.sortie
					? `\n - Sortie électrique ` + currentFormValue?.sortie?.value
					: ''
			} 
             `;
		};
		const options = [
			{
				id: 'avec',
				label: 'Avec capteur de vent',
				value: 'Avec capteur de vent',
				imageUrl: StoreCapteurVent,

				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Avec capteur de vent')),
				nextStep: false,
			},
			{
				id: 'sans',
				label: 'Sans capteur de vent',
				value: 'Sans capteur de vent',
				imageUrl: StoreSansCapteurVent,

				product_id: currentFormValue?.StoreBanneData?.id,
				description: generateDescription((data = 'Sans capteur de vent')),
				nextStep: false,
			},
		];

		fnSuccess(options);
	},
};

export const sortie = {
	id: 'sortie',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Sortie électrique (vue en face)',
	name: 'sortie',
	nextStepData: capteur,
	classGroup: 'SProduit',
	nextStep: false,
	options: [
		{
			id: 'gauche',
			label: '',
			value: 'gauche',
			imageUrl: gauche,
			nextStep: false,
		},
		{
			id: 'droite',
			label: '',
			value: 'droite',
			imageUrl: droite,
			nextStep: false,
		},
	],
};

export const telecommande = {
	id: 'telecommande',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de motorisation',
	name: 'telecommande',
	nextStepData: sortie,
	nextStep: false,
	options: [
		{
			id: 'motorisation_radio',
			// label: "Radio",
			value: 'Motorisation radio',
			imageUrl: Radio,

			nextStep: false,
		},
		{
			id: 'motorisation_filaire',
			//label: "Filaire",
			value: 'Motorisation filaire',
			imageUrl: Filaire,

			nextStep: false,
		},
		{
			id: 'motorisation_solaire',
			//  label: "Solaire",
			value: 'Motorisation solaire',
			imageUrl: Solaire,

			nextStep: false,
		},
	],
};

export default telecommande;
